var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useAddVenueToTeam, useListTeamHomeVenues, } from "../api/TeamVenueApiProvider";
import { useRetrieveTeam } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { AddVenueToEntity } from "../venues/AddVenueToEntity";
export var AddVenueToTeam = function () {
    var navigate = useNavigate();
    var teamId = useNumericParams().id;
    var _a = useRetrieveTeam({
        id: teamId,
    }), team = _a.data, teamLoading = _a.isLoading;
    var existingVenues = useListTeamHomeVenues({
        teamId: teamId,
        enabled: !!teamId,
    }).data;
    var addVenueMutation = useAddVenueToTeam({
        teamId: teamId,
        onSuccess: function () {
            navigate("/teams/".concat(teamId, "/venues/"));
        },
        onError: function () { },
    });
    var handleAdd = function (venueId, fromDate) {
        if (!teamId)
            return;
        addVenueMutation.mutate(__assign({ team: teamId, venue: venueId }, (fromDate && { fromDate: fromDate })));
    };
    if (teamLoading) {
        return _jsx(Loading, {});
    }
    if (!team || !teamId) {
        return _jsx(ErrorView, {});
    }
    // Get IDs of active venues to filter from search results
    var existingVenueIds = (existingVenues === null || existingVenues === void 0 ? void 0 : existingVenues.filter(function (v) { return v.isActive; }).map(function (v) { return v.venue.id; })) || [];
    return (_jsx(AddVenueToEntity, { entityName: "team", entityDisplayName: team.name, entityId: teamId, cancelUrl: "/teams/".concat(teamId, "/venues/"), existingVenueIds: existingVenueIds, addMutation: addVenueMutation, onAdd: handleAdd }));
};
